module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jean Porter\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("   "), _c('B', [_vm._v("Jean Porter")]), _vm._v(" is John A. O'Brien Professor of Theology at the University of Notre Dame. Her books include "), _c('I', [_vm._v("Natural and Divine Law")]), _vm._v(" and "), _c('I', [_vm._v("Nature as Reason")]), _vm._v(". ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/nfER5K/tc-custom/9781467446204.jpg?1742010563220",
      "alt": "This image is the cover for the book Justice as a Virtue"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Justice as a Virtue\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("“Aquinas,” says Jean Porter, “gets justice right.” In this book she shows that Aquinas offers us a cogent and illuminating account of justice as a "), _c('i', [_vm._v("personal")]), _vm._v(" virtue rather than a virtue of social institutions, as John Rawls and his interlocutors have described it — and as most people think of it today."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Porter presents a thoughtful interpretation of Aquinas’s account of the complex virtue of justice as set forth in the "), _c('i', [_vm._v("Summa theologiae,")]), _vm._v(" focusing on his key claim that justice is a perfection of the will. Building on her interpretation of Aquinas on justice, Porter also develops a constructive expansion of his work, illuminating major aspects of Aquinas’s views and resolving tensions in his thought so as to draw out contemporary implications of his account of justice that he could not have anticipated."), _c('br')]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0